<template>
  <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :sortInfo.sync="sortInfo" tableBorder="default" :pagination.sync="pagination" @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="getTargetLists" :highHoverRow="false" :highlightRow="false" />
</template>

<script>
import * as dayjs from 'dayjs';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { bizOppSendRecordPageList } from '@/api/niche.js';

export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    tenantId: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    columnList () {
      return [
        {
          tooltip: true,
          label: '商机号',
          minWidth: '',
          width: '120px',
          key: 'bizOppCode',
          prop: 'bizOppCode',
        },
        {
          tooltip: true,
          label: '商机标题',
          minWidth: '150px',
          width: '',
          key: 'bizOppTitle',
          prop: 'bizOppTitle',
        },
        {
          tooltip: true,
          label: '商机分类',
          minWidth: '200px',
          width: '',
          key: 'bizOppCategoryName',
          prop: 'bizOppCategoryName',
        },
        {
          tooltip: true,
          label: '商机品牌',
          minWidth: '120px',
          width: '',
          key: 'bizOppBrandName',
          prop: 'bizOppBrandName',
        },
        // {
        //   tooltip: true,
        //   label: '用户名称',
        //   minWidth: '120px',
        //   width: '',
        //   prop: 'tenantName',
        // },
        {
          tooltip: true,
          label: '推送时间',
          minWidth: '',
          width: '140px',
          key: 'createTime',
          prop: 'createTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '推送状态',
          minWidth: '',
          width: '80px',
          key: 'status',
          prop: 'status',
          slots: {
            default: ({ row }, h) => {
              let result = [];
              if ([1, '1'].includes(row.status)) {
                result.push((
                  <span>成功</span>
                ));
              }
              if ([2, '2'].includes(row.status)) {
                result.push((
                  <el-tooltip content={row.failureCause || '--'} placement="top-start">
                    <div>
                      <span>失败</span>
                      <span class="el-icon-info" style="margin-left:5px;font-size:14px;"></span>
                    </div>
                  </el-tooltip>
                ));
              }
              return [h('div', result)];
            },
          },
        },
      ];
    },
  },
  data () {
    return {
      targetLists: [],
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    getTargetLists () {
      const params = {
        tenantId: this.tenantId,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }

      bizOppSendRecordPageList(params).then(({ body }) => {
        this.targetLists = body?.list || [];
        this.pagination.total = Number(body?.total || 0);
      });
    },
  },
  mounted () {
    if (this.tenantId) {
      this.getTargetLists();
    }
  },
};
</script>
